export const CountryMapper = {
    'United States of America': 'US',
    'Dominican Rep.': 'Dominican Republic',
    'Côte d\'Ivoire': 'Cote d\'Ivoire',
    'Central African Rep.': 'Central African Republic',
    'S. Sudan': 'South Sudan',
    'South Korea': 'Korea, South',
    'Taiwan': 'Taiwan*',
    'Eq. Guinea': 'Equatorial Guinea',
    'Dem. Rep. Congo': 'Congo (Kinshasa)',
    'Congo': 'Congo (Brazzaville)'
}